// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resend-invoice-btn[data-v-6c06c86c]{margin:15px 0}", ""]);
// Exports
module.exports = exports;
